import "./actionfooter.scss";
import { ILinkModel, TOptionalType } from "../../core/models";

export interface IActionFooterProps {
  onHandleShare?: () => void;
  title?: string;
  content: {
    button_items?: TOptionalType<ILinkModel>[];
  };
}

const ActionFooter = ({ onHandleShare, content }: IActionFooterProps) => {
  const handleShare = (button: TOptionalType<ILinkModel>) => {
    if (onHandleShare) {
      onHandleShare();
    }

    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "native-share",
          title: button?.title,
          url: button?.url,
        })
      );
    }
  };

  return (
    <section className="action-share">
      <div className="inner">
        {content.button_items?.map((button: TOptionalType<ILinkModel>) => {
          return (
            <button onClick={() => handleShare(button)} className="btn primary">
              {button?.title}
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default ActionFooter;
